import {apolloUploadClient} from "../../plugins/apollo-client";
import UPLOAD_FILE from '../../graphql/upload/uploadFile.gql'

const uploadFile = (input, options) =>
  apolloUploadClient.mutate({
    mutation: UPLOAD_FILE,
    variables: {
      ...input
    },
    context: {
      fetchOptions:{
        onProgress: function (progress) {
          if (options.onProgress) {
            options.onProgress(progress)
          }
        }
      }
    },
  }).then(({data}) => data)
    .then(({file}) => file);

export {
  uploadFile
}
